export const regexValidPostalAddress = /^(?!^\d+$)[^~`!@#$%^*_+[\]{}\\|:;?><=\t\n\r]+$/iu;
export const regexValidSuburb = /^[^~`!@#$%^*_+[\](){}\\|:;?><=.\t\n\r\d]+$/i;
export const regexTextOnly = /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/;
export const regexValidUrl =
  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
export const regexValidRelativeUrl = /^\/?(?!.*\.\.)[\w\-./]*(\?[\w\-=&[\]%]+)?(#[\w-]+)?$/;

export const regexCreditCards = {
  visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
  mastercard: /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
  amex: /^3[47][0-9]{13}$/,
  discover: /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
  diners_club: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
  jcb: /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/,
};

export const regexValidEmail = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:{}!|\s@"-](?:[^<>()[\].,;:{}!|\s@"]*[^<>()[\].,;:{}!|\s@"-])?\.)+[^<>()[\].,;:\s@"-][^<>()[\].,;:\s@"]*[^<>()[\].,;:\s@"-])$/i;
